// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-require-imports */

if (process.env.NODE_ENV === "production") {
	module.exports = require("./configureStore.prod");
} else {
	module.exports = require("./configureStore.dev");
}
